import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Core component
import Tooltip from 'components/core/Tooltip';
// Custom
import { cpmCustomerDataShape, cpmOneparkBookingDataShape } from 'constants/PropTypesShapes';
import TableCellInformationItem from 'components/items/TableCellInformationItem';
import { LocalizedMessage } from 'intl/LocalizedComponents';

const CustomerEmailTableCellItem = ({ customer }) => {
  const tooltipContent = (customer && customer.email) ? customer.email : <LocalizedMessage id="tooltip.noEmail" />;

  return (
    <Tooltip content={tooltipContent}>
      <TableCellInformationItem
        value={customer.email}
      />
    </Tooltip>
  );
};

CustomerEmailTableCellItem.propTypes = {
  customer: PropTypes.oneOfType([
    cpmCustomerDataShape,
    cpmOneparkBookingDataShape,
  ]).isRequired,
};

module.exports = connect(
)(CustomerEmailTableCellItem);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/customers/CustomerEmailTableCellItem.js